<div class="progress-track">
  <div
    class="progress-fill"
    [style.width.%]="clampedProgress"
    [style.background]="color">
  </div>
</div>
